import React, { useEffect, useRef } from 'react';
import styles from './Videos.module.css';
import { VideosProjectGalleryInterface } from '../../../../../../../lib/types/videosProjectGallery';
import { getVideoUrl } from '../../../../../../../lib/sanity.client';

export type VideosProps = {
  videosPG: VideosProjectGalleryInterface | null;
};

const Videos: React.FC<VideosProps> = ({ videosPG }) => {

    const videoRef = useRef<HTMLDivElement | null>(null);
    
    useEffect(() => {
        const videos = videoRef.current?.querySelectorAll('video');

        const handleScroll = () => {
            if (videos) {
                videos.forEach((video) => {
                    const rect = video.getBoundingClientRect();
                    const isInView = rect.top >= 0 && rect.bottom <= window.innerHeight;

                    if (isInView) {
                        const playPromise = video.play();
                        if (playPromise !== undefined) {
                            playPromise.catch((error) => {
                                console.error('Error playing video:', error);
                            });
                        }
                    } else {
                        video.pause();
                    }
                });
            }
        };

        window.addEventListener('scroll', handleScroll);
        handleScroll();

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [videosPG]); // Run this effect when videosPG changes

    return (
        <>
        {videosPG &&
            <div className={styles.container} ref={videoRef}>
            {videosPG.videos.map((video, index) => (
                <div className={styles.normal} key={index} >
                    <video
                        controls
                        className={styles.video}
                        muted // Keep muted initially for autoplay
                        loop
                    >
                        <source src={getVideoUrl(video) || ''} type="video/mp4" />
                    </video>
                </div>
            ))}
            </div>
        }
        </>
    );
};

export default Videos;
